const riot = require('riot');

riot.tag2('module-works', '<div class="relative f fm"> <div class="f overflow-scroll scrollbar-none l-flex-nowrap mr16 scroll-snap-x-mandatory transition {&quot;transparent-mask&quot; : getCurrentPage() !== opts.works.length - 1}" ref="container" onscroll="{_.noop}"> <div class="flex-fixed w80per rounded-10 overflow-hidden scroll-snap-align-center mr16 s-mb16" each="{work, index in opts.works}"> <video class="s-full" riot-src="{work.url}#t=1.00" controls muted playsinline></video> </div> <div class="w1 h1 flex-fixed"></div> </div> </div> <div class="f px64"> <div class="w-full py16 cursor-pointer mr4 mr0-last" each="{v, i in opts.works}" onclick="{onScrollToWork}"> <div class="h3 {i === getCurrentPage() ? &quot;bg-white&quot; : &quot;bg-deepgray&quot;}"></div> </div> </div>', 'module-works,[data-is="module-works"]{display:block}', '', function(opts) {
    this.on('mount', () => {
      this.ITEM_WIDTH_PER = 0.8;
    });

    this.getCurrentPage = () => {
      var buffer = this.refs.container.offsetWidth * (1 - this.ITEM_WIDTH_PER);
      var left = this.refs.container.scrollLeft;
      var itemWidth = this.refs.container.offsetWidth * this.ITEM_WIDTH_PER;

      if (left <= 0) {
        return 0;
      }

      else if (left >= this.refs.container.scrollWidth - this.refs.container.clientWidth) {
        return this.opts.works.length - 1;
      }

      else {
        return Math.floor(left / (itemWidth - buffer / 2));
      }
    };

    this.onScrollToWork = (e) => {
      this.refs.container.children[e.item.i].scrollIntoView({behavior: 'smooth', block: 'center', inline: 'center'});
    };
});